// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2aSzU","checkboxCol":"Table_checkboxCol__36uhx","emailCol":"Table_emailCol__3VlEU","actionCol":"Table_actionCol__1oPk4"};